import type {
  LeadForm,
  LeadFormInput,
  LeadFormPrefs,
  LeadFormPrefsInput,
  LeadFormSubmission,
} from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from "./client";

export function listLeadForms(): Promise<{ forms: LeadForm[] }> {
  return apiGet("/api/forms");
}

export function createLeadForm(
  input: LeadFormInput,
): Promise<{ form: LeadForm }> {
  return apiPost("/api/forms", input);
}

export function getLeadForm(
  formId: string,
): Promise<{ form: LeadForm }> {
  return apiGet(`/api/forms/${encodeURIComponent(formId)}`);
}

export function updateLeadForm(
  formId: string,
  patch: LeadFormInput,
): Promise<{ form: LeadForm }> {
  return apiPatch(`/api/forms/${encodeURIComponent(formId)}`, patch);
}

export function deleteLeadForm(formId: string): Promise<void> {
  return apiDelete(`/api/forms/${encodeURIComponent(formId)}`);
}

export function publishLeadForm(
  formId: string,
  body?: { domains?: string[] },
): Promise<{
  form: LeadForm;
  embed: {
    hosted: string;
    enrichment: string;
    scriptUrl: string;
    publicUrl: string;
  };
}> {
  return apiPost(
    `/api/forms/${encodeURIComponent(formId)}/publish`,
    body ?? {},
  );
}

export function listFormSubmissions(
  formId: string,
): Promise<{ submissions: LeadFormSubmission[] }> {
  return apiGet(`/api/forms/${encodeURIComponent(formId)}/submissions`);
}

export function getFormEmbed(formId: string): Promise<{
  hosted: string;
  enrichment: string;
  scriptUrl: string;
  publicUrl: string;
}> {
  return apiGet(`/api/forms/${encodeURIComponent(formId)}/embed`);
}

export function enrichFormPreview(
  formId: string,
  email: string,
): Promise<{ values: Record<string, string>; leadId?: string }> {
  return apiPost(`/api/forms/${encodeURIComponent(formId)}/enrich-preview`, {
    email,
  });
}

export function getFormPreferences(): Promise<LeadFormPrefs> {
  return apiGet("/api/forms/preferences");
}

export function updateFormPreferences(
  input: LeadFormPrefsInput,
): Promise<LeadFormPrefs> {
  return apiPut("/api/forms/preferences", input);
}
